<app-modal-refactor
  [size]="sizeModal || 'lg'"
  [showImage]="!!image && !isDobModal && !isPassportAmbiguityModal"
  [image]="image"
  [isNoCkn]="true"
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]="true"
>
  <div body class="containerError">
    <div *ngIf="isDobModal && image" class="dob-modal-icon gapline">
      <img [src]="image" alt="passport verify" class="dob-modal-icon-img" />
    </div>
    <div *ngIf="isPassportAmbiguityModal && image" class="dob-modal-icon gapline">
      <img [src]="image" alt="passport verify" class="dob-modal-icon-img" />
    </div>
    <span class="tittleError gapline" [ngStyle]="{ 'font-weight': fontWeightTitleError }">{{
      titleError | translate
    }}</span>
    <span
      class="fs-28px gapline text-white descError"
      style="margin-bottom: 0"
      [innerText]="msgError | translate"
    ></span>
    <div *ngIf="dobLabel" class="dob-line gapline">
      <span class="dob-line-label">{{ dobLabel | translate }}</span>
      <span class="dob-line-value">{{ dobValue }}</span>
    </div>
    <div *ngIf="passportNumberLabel" class="dob-line gapline">
      <span class="dob-line-label">{{ passportNumberLabel | translate }}</span>
      <span class="dob-line-value">{{ passportNumberValue }}</span>
    </div>
    <span *ngIf="!isAllPass && showListPassengers" class="textpasseger gapline text-white">{{
      'modalnockn.pssmst' | translate
    }}</span>
    <div *ngIf="!isAllPass && showListPassengers">
      <span *ngFor="let p of passengerSelected" class="textpss-labels"
        >{{ p.displayName | titlecase }}<br
      /></span>
    </div>
    <div
      class="errorsBtnsPnr gapline"
      [ngClass]="{ 'dob-btns-row': isDobModal || isPassportAmbiguityModal }"
    >
      <button
        *ngIf="showCancelButton && (isDobModal || isPassportAmbiguityModal)"
        type="button"
        class="error-btn dob-btn-cancel"
        (click)="actionBtnCancel()"
      >
        <div class="error-btn-container">
          <span>{{ cancelButtonText | translate }}</span>
        </div>
      </button>
      <button
        *ngIf="showButton"
        type="button"
        class="error-btn {{ backGroundButton }} {{ colorFontButton }}"
        [ngClass]="{ 'dob-btn-confirm': isDobModal || isPassportAmbiguityModal }"
        (click)="actionBtn()"
      >
        <div class="error-btn-container">
          <img *ngIf="showIconImage" class="error-btn-img" [src]="urlIconImage" alt="Reload" />
          <span>{{ buttonCopy | translate }}</span>
        </div>
      </button>
      <button
        *ngIf="showCancelButton && !isDobModal && !isPassportAmbiguityModal"
        type="button"
        class="error-btn {{ backGroundButton }} {{ colorFontButton }}"
        (click)="actionBtnCancel()"
      >
        <div class="error-btn-container">
          <span>{{ cancelButtonText | translate }}</span>
        </div>
      </button>
    </div>
    <div>
      <span class="errorNumberDescrip">{{ codeError }} </span>
    </div>
  </div>
</app-modal-refactor>
